<template>
  <table class="table">
    <thead>
      <tr>
        <slot name="columns">
          <th v-for="column in columns" v-show="showColumn(column)" v-on:click="sortBy(column)" :class="[thClass(column)]">
          <i v-if="column==sortColumn" :class="['fa',{'fa-long-arrow-down': sortDir==1,'fa-long-arrow-up': sortDir!=1}]"></i>
          {{column.text}}
          </th>
        </slot>
      </tr>
    </thead>
    <tfoot>
      <tr v-if="loading">
        <td v-bind:colspan="columns.length">
          <center>
            <p class="card-category">Caricamento in corso...</p>
          </center>
        </td>
      </tr>
    </tfoot>
    <tbody>
    <tr v-for="item in rows" v-if="showItem(item)" :class="[trClass(item)]">
      <slot :row="item">
        <td v-for="column in columns" v-show="showColumn(column)" :class="[tdClass(item,column)]" v-on:click="itemClick(item,column)">
          <div v-if="column.renderAsHtml" v-html="itemValue(item, column)">
          </div>
          <div v-else v-text="itemValue(item, column)">
          </div>
        </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table',
    props: {
      parent: Object,
      url: String,
      columns: Array, // possible keys: key, text, renderer (function), getCellClass (function), getHeaderClass (function)
      getRowClass: Function,
      data: Array,
      pattern: String
    },
    data () {
      return {
        rows: [],
        loading: false,
        sortColumn: null,
        sortDir: 1
      }
    },
    mounted () {
      if (this.$props.url) {
        this.ajaxLoad()
      } else {
        this.rows = this.data
      }
    },
    watch: {
      url: function (value) {
        if (value) {
          this.ajaxLoad()
        }
      }
    },
    methods: {
      getParent: function () {
        return this.$props.parent ? this.$props.parent : this.$parent
      },
      showItem (item) {
        if (!this.pattern) {
          return true
        }
        var words = this.pattern.split(/\W+/)
        for (var i = 0; i < words.length; ++i) {
          if (words[i].length > 0) {
            var trovata = false
            var parola = words[i].toUpperCase()
            for (var j = 0; j < this.columns.length; ++j) {
              var txt = ''
              if (typeof this.columns[j].renderer === 'function') {
                txt = this.columns[j].renderer.apply(this.getParent(), [item])
              } else {
                txt = item[this.columns[j].key]
              }
              if (typeof txt === 'string') {
                var testo = txt.toUpperCase()
                if (testo.indexOf(parola) !== -1) {
                  trovata = true
                }
              }
            }
            if (!trovata) {
              return false
            }
          }
        }
        return true
      },
      showColumn: function (column) {
        if (typeof column.show === 'undefined') {
          return true
        }
        if (typeof column.show === 'function') {
          return column.show.apply(this.getParent(), [])
        }
        return column.show
      },
      itemValue (item, column) {
        return typeof column.renderer === 'function' ? column.renderer.apply(this.getParent(), [item]) : item[column.key]
      },
      trClass (item) {
        return typeof this.getRowClass === 'function' ? this.getRowClass(item) : ''
      },
      tdClass (item, column) {
        return typeof column.getCellClass === 'function' ? column.getCellClass(item) : ''
      },
      thClass (column) {
        return typeof column.getHeaderClass === 'function' ? column.getHeaderClass() : ''
      },
      sortBy (column) {
        var me = this
        if (me.sortColumn === column) {
          me.sortDir *= -1
        } else {
          me.sortColumn = column
          me.sortDir = 1
        }
        var sortFn = function (a, b) {
          var valA = (me.sortColumn.key ? a[me.sortColumn.key] : me.itemValue(a, me.sortColumn))
          var valB = (me.sortColumn.key ? b[me.sortColumn.key] : me.itemValue(b, me.sortColumn))
          if (typeof valA === 'undefined' || valA === null) {
            valA = ''
          }
          if (typeof valB === 'undefined' || valB === null) {
            valB = ''
          }
          if (valA === '' && valB !== '') return me.sortDir * -1
          if (valA !== '' && valB === '') return me.sortDir
          if (valA < valB) return me.sortDir * -1
          if (valA > valB) return me.sortDir
          return 0
        }
        this.rows.sort(sortFn)
      },
      itemClick: function (item, column) {
        this.$emit('onClick', item, column)
      },
      ajaxLoad () {
        var me = this
        me.loading = true
        var url = me.url
        var method = 'GET'
        var params = {}
        var successFn = function (data) {
          me.loading = false
          me.rows = data
        }
        var errorFn = function (message) {
          me.loading = false
          me.ajaxErrorFn(message)
        }
        me.ajax(url, method, params, successFn, errorFn)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Table.vue